import { Box } from '@mui/material';

import { getInfluenceTypeLabel, getLocationTypeLabel } from '../../azk-binging.utils';

import { CompetitorBindingTableProps } from './CompetitorBindingTable.types';

import './CompetitorBindingTable.css';

export function CompetitorBindingTable({
  bindings,
  selectedCompetitorStation,
  influenceTypes,
  locationTypes
}: CompetitorBindingTableProps) {
  if (bindings.length === 0) return null;

  return (
    <>
      {bindings.map(okkoBinding => (
        <Box key={okkoBinding.okkoStationUnicode} className="competitor-binding-table">
          <Box className="competitor-binding-header">
            <Box className="competitor-binding-header-cell azk-binding-col-8">Юнікод</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-40">Адреса</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-15">Бренд АЗК</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-12">Тип впливу</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-15">Тип розміщення</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-10">Відстань до АЗК</Box>
            <Box className="competitor-binding-header-cell azk-binding-col-10">Відстань по прямій</Box>
          </Box>

          <Box className="competitor-binding-row okko-row">
            <Box className="competitor-binding-cell azk-binding-col-8">{okkoBinding.okkoStation?.unicode}</Box>
            <Box className="competitor-binding-cell azk-binding-col-40">{okkoBinding.okkoStation?.address}</Box>
            <Box className="competitor-binding-cell azk-binding-col-15">
              <Box className="brand-badge okko">{okkoBinding.okkoStation?.brand}</Box>
            </Box>
            <Box className="competitor-binding-cell azk-binding-col-12"></Box>
            <Box className="competitor-binding-cell azk-binding-col-15"></Box>
            <Box className="competitor-binding-cell azk-binding-col-10"></Box>
            <Box className="competitor-binding-cell azk-binding-col-10"></Box>
          </Box>

          <Box className="competitor-binding-row competitor-row">
            <Box className="competitor-binding-cell azk-binding-col-8">{selectedCompetitorStation?.unicode}</Box>
            <Box className="competitor-binding-cell azk-binding-col-40">{selectedCompetitorStation?.address}</Box>
            <Box className="competitor-binding-cell azk-binding-col-15">
              <Box className="brand-badge competitor">{selectedCompetitorStation?.brand}</Box>
            </Box>
            <Box className="competitor-binding-cell azk-binding-col-12">
              {getInfluenceTypeLabel(influenceTypes, okkoBinding.binding.influence_type)}
            </Box>
            <Box className="competitor-binding-cell azk-binding-col-15">
              {getLocationTypeLabel(locationTypes, okkoBinding.binding.location_type)}
            </Box>
            <Box className="competitor-binding-cell azk-binding-col-10">{okkoBinding.binding.distance_to_azk} км</Box>
            <Box className="competitor-binding-cell azk-binding-col-10">{okkoBinding.binding.straight_distance} км</Box>
          </Box>
        </Box>
      ))}
    </>
  );
}
